import { Symbol } from './Symbol'

/**
 * Ein Schalter für „an oder aus, sofort wirksam".
 *
 * Ein `<button role="switch">` statt eines Kästchens: ein Kästchen sammelt
 * eine Wahl, die später abgeschickt wird — ein Schalter wirkt beim Umlegen.
 * Der Haken im Daumen macht den An-Zustand auch ohne Farbe erkennbar.
 */
export function Switch({
  checked,
  onChange,
  label,
  disabled = false,
}: {
  checked: boolean
  onChange: (naechster: boolean) => void
  label: string
  disabled?: boolean
}) {
  return (
    <label className={`sw${disabled ? ' sw--aus' : ''}`}>
      <span className="sw__text">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className="sw__spur"
        onClick={() => onChange(!checked)}
      >
        <span className="sw__daumen">
          {checked ? <Symbol name="check" className="sw__haken" /> : null}
        </span>
      </button>
    </label>
  )
}
